import React, { Component, Fragment } from 'react';
import { NavLink } from 'redux-first-router-link'; 
import { connect } from 'react-redux';
import './lander-pw-citi.scss';
import Loading from '../App/Loading'; // can be a hasLoading() HOC in the future
import MetaTags from '../common/MetaTags';
import OutboundLink from '../common/OutboundLink';
import Nav from '../Nav';
import { segmentTrackPage, segmentTrackEvent, sendLog } from '../../utils';
import { SITE_HOST } from '../../consts';

class Lander extends Component {
  constructor() {
    super();
    this.state = {
      
    };
    this.renderHonorees = this.renderHonorees.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
      const { target } = e;
      const targetTagName = target.tagName.toLowerCase();
      let trackableElement = target;
      let innerHTML = '';
      if ((targetTagName === 'a') || ((targetTagName === 'img') && (target.parentNode.tagName.toLowerCase() === 'a')) || this.props.dataEventName) {
        if (targetTagName === 'img') {
          trackableElement = target.parentNode;
          innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
        } else {
          ({ innerHTML } = target);
        }
      }
      const destinationUrl = trackableElement.getAttribute('href');
      const linkType = trackableElement.getAttribute('data-link-type') || 'text-link';
      const articleClickedTracker = {
        destinationUrl,
        module: 'honoree-grid-logo',
        hypercontext: innerHTML, // need to handle this more elegantly
        category: linkType,
        linkType,
        label: destinationUrl,
      };
      segmentTrackEvent('article_clicked', articleClickedTracker);
  }

  componentDidMount() {
    segmentTrackPage();
  }

  componentDidUpdate(prevProps) {
    
  }

  renderHonorees(articles, isMobile) {
    let honorees = articles.map((article, a) => {
      let { landerImage, name, bio, short, url } = article;
      let slide = url.replace('/', '');
      let action = { type: 'SLIDESHOW', payload: { slide } };
      let link = `/20-in-20/honorees${url}`;
      let divClass = isMobile ? 'honoree-tile' : `honoree-tile div${a}`;
      let i = isMobile ? 0 : 5;
      if (a === i) {
        return (
          <Fragment>
          <div className="logo">
            <OutboundLink href="https://www.citigroup.com/citi/about/its-about-time/" onClick={this.handleClick}><img src="https://static.cdn.gallerymediagroup.com/citi20in20/logos/20-in-20-logo.svg" /></OutboundLink>
          </div>
          <div className={divClass}>
            <NavLink to={link}>
            <img src={landerImage} />
            <div className='honoree-content'>
              <h2 dangerouslySetInnerHTML={{__html: name}} />
              <p>Read Her Interview</p>
            </div>
            </NavLink>
          </div>
          </Fragment>
        );
      } else {
        return (
          <div className={divClass}>
            <NavLink to={link}>
            <img src={landerImage} />
            <div className='honoree-content'>
              <h2 dangerouslySetInnerHTML={{__html: name}} />
              <p>Read Her Interview</p>
            </div>
            </NavLink>
          </div>
        );
      }
    });
    return honorees;
  }

  render() {
    const { committee, articles, brand, isLoading, meta, logo, isMobile }  = this.props;
    if (isLoading) {
      return <Loading />;
    }
    const fullUrl = `${meta.url}/honorees`;
    const renderedHonorees = this.renderHonorees(articles, isMobile);
    const parentClass = isMobile ? "honorees mobile" : "honorees desktop";
    let timestamp = Date.now();
    let pixelSrc = `https://ad.doubleclick.net/ddm/ad/N458401.3830497PUREWOW/B24733775.284161726;sz=1x1;ord=${timestamp};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`;
    let pixelSrc2 = `https://secure.insightexpressai.com/adServer/adServerESI.aspx?script=false&bannerID=7781475&rnd=${timestamp}&gdpr=&gdpr_consent=&redir=https://secure.insightexpressai.com/adserver/1pixel.gif`
    return (
      <Fragment>
        <MetaTags
          title={meta.title}
          description={meta.description}
          url={fullUrl}
          ogTitle={meta.title}
          ogDescription={meta.description}
          ogImage={meta.image}
          ogImageWidth="600px"
          ogImageHeight="600px"
          twitterDescription={meta.description}
          twitterImg={meta.image}
          canonicalUrl={fullUrl} />
          <img src={pixelSrc} border="0" width="1" height="1" ALT="Advertisement" />
          <img src={pixelSrc2} border="0" width="1" height="1" ALT="Advertisement" />
          <Nav page='honorees' />
          <div className={parentClass}>
            {renderedHonorees}
          </div>

      </Fragment>
    );
  }
}
const mapState = (state) => {
  const { pageData, isMobile } = state;
  const { pageType, articles, brand, committee, logo, meta } = pageData;
  /*
    Handles first action dispatched when clicking redux-first-router Link or NavLink.

    This first action just updates the location in the redux store but doesn't fetch any data
    or update the actual contents of the page.

    A second action is dispatched once the thunk associated with the new route/location finishes running.
    In this case, the thunk internally makes an async request to the server to get new data based on the redux
    state's location.
  */

  console.log(pageType);

  if (pageType !== "lander") {

    return {
      articles: [],
      brand: "",
      isLoading: true
    };
  }

  return {
    pageType,
    isMobile,
    articles, 
    brand, 
    isLoading: false,
    committee,
    logo,
    meta
  }
}
export default connect(mapState)(Lander)

